<template>
<nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul class="" style="list-style: none">
        <li :class="{ topmenuactive: activeTab === 'hethongcntt' }" @click="changeTab('hethongcntt')">
            <a id="urlhethongcntt" href="vi/chuongtrinhtaitroxathidiem#haiphong/hethongcntt" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'xatranphu' }" @click="changeTab('xatranphu')">
            <a id="urlXatranPhu" href="vi/chuongtrinhtaitroxathidiem#haiphong/xatranphu" style="color: white;">{{ currentLanguage.header_text_TranPhu }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xanamsach' }" @click="changeTab('Xanamsach')">
            <a id="urlXanamsach" href="vi/chuongtrinhtaitroxathidiem#haiphong/xanamsach" style="color: white;">{{ currentLanguage.header_text_NamSach }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'xathaitan' }" @click="changeTab('xathaitan')">
            <a id="urlXathaitan" href="vi/chuongtrinhtaitroxathidiem#haiphong/xathaitan" style="color: white;">{{currentLanguage.header_text_ThaiTan}}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xaanphu' }" @click="changeTab('Xaanphu')">
            <a id="urlXaanphu" href="vi/chuongtrinhtaitroxathidiem#haiphong/xaanphu" style="color: white;">  {{ currentLanguage.header_text_AnPhu }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xahoptien' }" @click="changeTab('Xahoptien')">
            <a id="urlXahoptien" href="vi/chuongtrinhtaitroxathidiem#haiphong/xahoptien" style="color: white;"> {{ currentLanguage.header_text_HopTien }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Vietkhe' }" @click="changeTab('Vietkhe')">
            <a id="urlVietkhe" href="vi/chuongtrinhtaitroxathidiem#haiphong/vietkhe" style="color: white;"> {{ currentLanguage.header_text_VietKhe }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xaanlao' }" @click="changeTab('Xaanlao')">
            <a id="urlXaanlao" href="vi/chuongtrinhtaitroxathidiem#haiphong/xaanlao" style="color: white;"> {{ currentLanguage.header_text_AnLao }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xaantruong' }" @click="changeTab('Xaantruong')">
            <a id="urlXaantruong" href="vi/chuongtrinhtaitroxathidiem#haiphong/xaantruong" style="color: white;"> {{ currentLanguage.header_text_AnTruong }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xaphuthai' }" @click="changeTab('Xaphuthai')">
            <a id="urlXaphuthai" href="vi/chuongtrinhtaitroxathidiem#haiphong/xaphuthai" style="color: white;">  {{ currentLanguage.header_text_PhuThai }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xakimthanh' }" @click="changeTab('Xakimthanh')">
            <a id="urlXakimthanh" href="vi/chuongtrinhtaitroxathidiem#haiphong/xakimthanh" style="color: white;">    {{ currentLanguage.header_text_KimThanh }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xaanthanh' }" @click="changeTab('Xaanthanh')">
            <a id="urlXaanthanh" href="vi/chuongtrinhtaitroxathidiem#haiphong/xaanthanh" style="color: white;">{{ currentLanguage.header_text_AnThanh }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xaankhanh' }" @click="changeTab('Xaankhanh')">
            <a id="urlXaankhanh" href="vi/chuongtrinhtaitroxathidiem#haiphong/xaankhanh" style="color: white;">  {{ currentLanguage.header_text_AnKhanh }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xavinhbao' }" @click="changeTab('Xavinhbao')">
            <a id="urlXavinhbao" href="vi/chuongtrinhtaitroxathidiem#haiphong/xavinhbao" style="color: white;">{{ currentLanguage.header_text_VinhBao }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xanguyenbinhkhiem' }" @click="changeTab('Xanguyenbinhkhiem')">
            <a id="urlXanguyenbinhkhiem" href="vi/chuongtrinhtaitroxathidiem#haiphong/xanguyenbinhkhiem" style="color: white;">{{ currentLanguage.header_text_NguyenBinhKhiem }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xavinhhai' }" @click="changeTab('Xavinhhai')">
            <a id="urlXavinhhai" href="vi/chuongtrinhtaitroxathidiem#haiphong/xavinhhai" style="color: white;"> {{ currentLanguage.header_text_VinhHai }}</a>
        </li>

    </ul>
</nav>
<div class="wrapper row3">
       <main class="hoc container-fluid clear bv p-0">

                <!-- Xanamsach -->
                <div v-if="showXaanphu" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaanphu"></div>
                    <div v-html="contentHtmlXaanphu"></div>
                    <!-- Đang cập nhật... -->
                </div>
                <div v-if="showXatranPhu" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXatranPhu"></div>
                    <div v-html="contentHtmlXatranPhu"></div>
                    <!-- Đang cập nhật... -->
                </div>
                <div v-if="showXahoptien" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXahoptien"></div>
                    <div v-html="contentHtmlXahoptien"></div>
                    <!-- Đang cập nhật... -->
                </div>
                <div v-if="showCopilot" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlCopilot"></div>
                    <div v-html="contentHtmlCopilot"></div>
                </div>
                <div v-if="showGrok" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlGrok"></div>
                    <div v-html="contentHtmlGrok"></div>
                </div>
                <div v-if="showXathaitan" class="padding-top15">

                    <div class="title-bai-viet" v-html="titleHtmlXathaitan"></div>
                    <div v-html="contentHtmlXathaitan"></div>

                </div>
                <div v-if="showVietkhe" class="padding-top15">

                    <div class="title-bai-viet" v-html="titleHtmlVietkhe"></div>
                    <div v-html="contentHtmlVietkhe"></div>
                </div>
                <div v-if="showXanamsach" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXanamsach"></div>
                    <div v-html="contentHtmlXanamsach"></div>
                    <!-- Đang cập nhật... -->
                </div>
                <!-- An Lão -->
                <div v-if="showXaanlao" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaanlao"></div>
                    <div v-html="contentHtmlXaanlao"></div>
                </div>

                <!-- Vĩnh Bảo -->
                <div v-if="showXavinhbao" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXavinhbao"></div>
                    <div v-html="contentHtmlXavinhbao"></div>
                </div>

                <!-- <div v-if="showXanguyenbinhkhiem" class="padding-top15">
            Đang cập nhật...
          </div> -->

                <!-- An Trường -->
                <div v-if="showXaantruong" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaantruong"></div>
                    <div v-html="contentHtmlXaantruong"></div>
                </div>

                <!-- Phú Thái -->
                <div v-if="showXaphuthai" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaphuthai"></div>
                    <div v-html="contentHtmlXaphuthai"></div>
                </div>

                <!-- Kim Thành -->
                <div v-if="showXakimthanh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXakimthanh"></div>
                    <div v-html="contentHtmlXakimthanh"></div>
                </div>

                <!-- An Thành -->
                <div v-if="showXaanthanh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaanthanh"></div>
                    <div v-html="contentHtmlXaanthanh"></div>
                </div>

                <!-- Vĩnh Hải -->
                <div v-if="showXavinhhai" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXavinhhai"></div>
                    <div v-html="contentHtmlXavinhhai"></div>
                </div>

                <!-- An Khanh -->
                <div v-if="showXaankhanh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaankhanh"></div>
                    <div v-html="contentHtmlXaankhanh"></div>
                </div>
                <!-- Nguyễn Bỉnh Khiêm -->
                <div v-if="showXanguyenbinhkhiem" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXanguyenbinhkhiem"></div>
                    <div v-html="contentHtmlXanguyenbinhkhiem"></div>
                </div>

                <div v-if="showHethongcntt" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHethongcntt"></div>
                    <div v-html="contentHtmlHethongcntt"></div>
                </div>
         
    </main>
</div>
</template>

<script>
import {
    languages
} from "@/components/languages";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";

export default {
    components: {

    },
    data() {
        return {
            activeTab: 'hethongcntt',

            currentLanguage: languages.vi,
            lang: "",
            base64: "",
            base64Title: "",
            showXaanphu: false,
            showXatranPhu: false,
            showXahoptien: false,
            showCopilot: false,
            showGrok: false,
            showXathaitan: false,
            showVietkhe: false,
            showXanamsach: false,
            showUngDungAI: false,

            showHethongcntt: true,
            titleHethongcntt: "",
            contentHtmlHethongcntt: "",

            titleHtmlAITaiLopHoc: "",
            contentHtmlAITaiLopHoc: "",
            titleHtml: "",
            contentHtml: "",
            titleHtmlTruongTaiTro: "",
            contentHtmlTruongTaiTro: "",
            titleHtmlTH: "",
            contentHtmlTH: "",
            titleHtmlTHCS: "",
            contentHtmlTHCS: "",
            titleHtmlTHPT: "",
            contentHtmlTHPT: "",
            titleHtmlLienHe: "",
            contentHtmlLienHe: "",
            titleHtmlLienCap: "",
            contentHtmlLienCap: "",

            titleHtmlXanamsach: "",
            titleHtmlXaanphu: "",
            titleHtmlXatranPhu: "",
            titleHtmlXahoptien: "",
            titleHtmlCopilot: "",
            titleHtmlGrok: "",
            titleHtmlXathaitan: "",
            titleHtmlVietkhe: "",

            contentHtmlXanamsach: "",
            contentHtmlXaanphu: "",
            contentHtmlXatranPhu: "",
            contentHtmlCopilot: "",
            contentHtmlXahoptien: "",
            contentHtmlGrok: "",
            contentHtmlXathaitan: "",
            contentHtmlVietkhe: "",

            showXaanlao: false,
            showXavinhbao: false,
            showXanguyenbinhkhiem: false,
            showXaantruong: false,
            showXaphuthai: false,
            showXakimthanh: false,
            showXaanthanh: false,
            showXavinhhai: false,
            showXaankhanh: false,

            titleHtmlXaanlao: "",
            contentHtmlXaanlao: "",
            titleHtmlXavinhbao: "",
            contentHtmlXavinhbao: "",
            titleHtmlXanguyenbinhkhiem: "",
            contentHtmlXanguyenbinhkhiem: "",
            titleHtmlXaantruong: "",
            contentHtmlXaantruong: "",
            titleHtmlXaphuthai: "",
            contentHtmlXaphuthai: "",
            titleHtmlXakimthanh: "",
            contentHtmlXakimthanh: "",
            titleHtmlXaanthanh: "",
            contentHtmlXaanthanh: "",
            titleHtmlXavinhhai: "",
            contentHtmlXavinhhai: "",
            titleHtmlXaankhanh: "",
            contentHtmlXaankhanh: "",
        };
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true;
            this.lang = localStorage.getItem("languages") || "vi";
            console.log("lang ", this.lang);
            
            // this.performPostRequest("1695975526923tLcPE", "Xanamsach", this.lang);
            document.getElementById("urlhethongcntt").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/hethongcntt");
            document.getElementById("urlXatranPhu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xatranphu");
            document.getElementById("urlXanamsach").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xanamsach");
            document.getElementById("urlXathaitan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xathaitan");
            document.getElementById("urlXaanphu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xaanphu");
            document.getElementById("urlXahoptien").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xahoptien");
            document.getElementById("urlVietkhe").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/vietkhe");
            document.getElementById("urlXaanlao").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xaanlao/");
            document.getElementById("urlXaantruong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xaantruong");
            document.getElementById("urlXaphuthai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xaphuthai");
            document.getElementById("urlXakimthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xakimthanh");
            document.getElementById("urlXaanthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xaanthanh");
            document.getElementById("urlXaankhanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xaankhanh");
            document.getElementById("urlXavinhbao").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xavinhbao");
            document.getElementById("urlXanguyenbinhkhiem").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xanguyenbinhkhiem");
            document.getElementById("urlXavinhhai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#haiphong/xavinhhai");

            let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
            fragmentTab = fragmentTab.toLowerCase();
            console.log("fragmentTab " + fragmentTab);
            if (fragmentTab === "haiphong/xatranphu") {
                this.changeTab("xatranphu");
            } else if (fragmentTab === "haiphong/xanamsach") {
                this.changeTab("Xanamsach");
            } else if (fragmentTab === "haiphong/xathaitan") {
                this.changeTab("xathaitan");
            } else if (fragmentTab === "haiphong/xaanphu") {
                this.changeTab("Xaanphu");
            } else if (fragmentTab === "haiphong/xahoptien") {
                this.changeTab("Xahoptien");
            } else if (fragmentTab === "haiphong/copilot") {
                this.changeTab("Copilot");
            } else if (fragmentTab === "haiphong/grok") {
                this.changeTab("Grok");
            } else if (fragmentTab === "haiphong/vietkhe") {
                this.changeTab("Vietkhe");
            } else if (fragmentTab === "haiphong/hethongcntt") {
                this.changeTab("hethongcntt");
            } else if (fragmentTab === "haiphong/xaanlao") {
                this.changeTab("Xaanlao");
            } else if (fragmentTab === "haiphong/xaantruong") {
                this.changeTab("Xaantruong");
            } else if (fragmentTab === "haiphong/xaphuthai") {
                this.changeTab("Xaphuthai");
            } else if (fragmentTab === "haiphong/xakimthanh") {
                this.changeTab("Xakimthanh");
            } else if (fragmentTab === "haiphong/xaanthanh") {
                this.changeTab("Xaanthanh");
            } else if (fragmentTab === "haiphong/xaankhanh") {
                this.changeTab("Xaankhanh");
            } else if (fragmentTab === "haiphong/xavinhbao") {
                this.changeTab("Xavinhbao");
            } else if (fragmentTab === "haiphong/xanguyenbinhkhiem") {
                this.changeTab("Xanguyenbinhkhiem");
            } else if (fragmentTab === "haiphong/xavinhhai") {
                this.changeTab("Xavinhhai");
            } else {
                this.changeTab("hethongcntt");
            }
        }
    },
    created() {
        const savedLanguage = localStorage.getItem("languages");
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    methods: {
        changeLanguage(lang) {
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            window.location.reload();
        },

        async performPostRequest(id, section) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });

                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store separately for each section
                if (section === "Copilot") {
                    this.titleHtmlCopilot = decodeURIComponent(escape(title));
                    this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
                } else if (section === "Grok") {
                    this.titleHtmlGrok = decodeURIComponent(escape(title));
                    this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
                } else if (section === "xatranphu") {
                    this.titleHtmlXatranPhu = decodeURIComponent(escape(title));
                    this.contentHtmlXatranPhu = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanamsach") {
                    this.titleHtmlXanamsach = decodeURIComponent(escape(title));
                    this.contentHtmlXanamsach = decodeURIComponent(escape(decodedString));
                } else if (section === "xathaitan") {
                    this.titleHtmlXathaitan = decodeURIComponent(escape(title));
                    this.contentHtmlXathaitan = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaanphu") {
                    this.titleHtmlXaanphu = decodeURIComponent(escape(title));
                    this.contentHtmlXaanphu = decodeURIComponent(escape(decodedString));
                } else if (section === "Xahoptien") {
                    this.titleHtmlXahoptien = decodeURIComponent(escape(title));
                    this.contentHtmlXahoptien = decodeURIComponent(escape(decodedString));
                } else if (section === "Vietkhe") {
                    this.titleHtmlVietkhe = decodeURIComponent(escape(title));
                    this.contentHtmlVietkhe = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaantruong") {
                    this.titleHtmlXaantruong = decodeURIComponent(escape(title));
                    this.contentHtmlXaantruong = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaphuthai") {
                    this.titleHtmlXaphuthai = decodeURIComponent(escape(title));
                    this.contentHtmlXaphuthai = decodeURIComponent(escape(decodedString));
                } else if (section === "Xakimthanh") {
                    this.titleHtmlXakimthanh = decodeURIComponent(escape(title));
                    this.contentHtmlXakimthanh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaanthanh") {
                    this.titleHtmlXaanthanh = decodeURIComponent(escape(title));
                    this.contentHtmlXaanthanh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhbao") {
                    this.titleHtmlXavinhbao = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhbao = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhhai") {
                    this.titleHtmlXavinhhai = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhhai = decodeURIComponent(escape(decodedString));
                } else if (section === "hethongcntt") {
                    this.titleHethongcntt = decodeURIComponent(escape(title));
                    this.contentHtmlHethongcntt = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanguyenbinhkhiem") {
                    this.titleHtmlXanguyenbinhkhiem = decodeURIComponent(escape(title));
                    this.contentHtmlXanguyenbinhkhiem = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaanlao") {
                    this.titleHtmlXaanlao = decodeURIComponent(escape(title));
                    this.contentHtmlXaanlao = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaankhanh") {
                    this.titleHtmlXaankhanh = decodeURIComponent(escape(title));
                    this.contentHtmlXaankhanh = decodeURIComponent(escape(decodedString));
                } else {
                    this.titleHtml = decodeURIComponent(escape(title));
                    this.contentHtml = decodeURIComponent(escape(decodedString));
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        changeTab(tab) {
    
            this.lang = localStorage.getItem("languages");
            const tabStates = {
                xatranphu: false,
                Xanamsach: false,
                xathaitan: false,
                Xaanphu: false,
                Xahoptien: false,
                Copilot: false,
                ungDungAI: false,
                Vietkhe: false,
                Xaanlao: false,
                Xaantruong: false,
                Xaphuthai: false,
                Xakimthanh: false,
                Xaanthanh: false,
                Xaankhanh: false,
                Xavinhbao: false,
                Xanguyenbinhkhiem: false,
                Xavinhhai: false,
                hethongcntt: false,
            };

            this.performPostRequest(this.getPostId(tab), tab, this.lang);

            tabStates[tab] = true;
            this.activeTab = tab;
            this.showXaanphu = tabStates.Xaanphu;
            this.showXatranPhu = tabStates.xatranphu;
            this.showXahoptien = tabStates.Xahoptien;
            this.showCopilot = tabStates.Copilot;
            this.showGrok = tabStates.Grok;
            this.showXathaitan = tabStates.xathaitan;
            this.showVietkhe = tabStates.Vietkhe;
            this.showXanamsach = tabStates.Xanamsach;
            this.showHethongcntt = tabStates.hethongcntt;

            // xã mới
            this.showXaanlao = tabStates.Xaanlao;
            this.showXavinhbao = tabStates.Xavinhbao;
            this.showXanguyenbinhkhiem = tabStates.Xanguyenbinhkhiem;
            this.showXaantruong = tabStates.Xaantruong;
            this.showXaphuthai = tabStates.Xaphuthai;
            this.showXakimthanh = tabStates.Xakimthanh;
            this.showXaanthanh = tabStates.Xaanthanh;
            this.showXavinhhai = tabStates.Xavinhhai;
            this.showXaankhanh = tabStates.Xaankhanh;
        },
         initFromHash() {
      // lấy hash trên URL
      let hash = window.location.hash.replace("#", "")
      if (hash) {
        this.activeTab = hash
      } else {
        // mặc định chọn tab đầu tiên nếu không có hash
        this.activeTab = "hethongcntt"
      }
    },
        getPostId(tab) {
            // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
            const postIdMap = {
                Copilot: "1739962827008hEz13",
                Grok: "1741754513134ENfrm",
                hethongcntt: "1756981266521DXWZ9",

                xatranphu: "1756983399753AnRxa",
                Xanamsach: "1756997767969oqqhH",
                xathaitan: "1756984565369PxUW1",
                Xaanphu: "1756982580615PlSvf",
                Xahoptien: "1756983006580XLkIm",
                Vietkhe: "1756983426908IsDnN",
                Xaanlao: "1756997896667A0GxW",
                Xaantruong: "1756982988260Lm6X9",
                Xaphuthai: "1756984707227yiFs8",
                Xakimthanh: "1756983130480UpQrX",
                Xaanthanh: "1756983067859uMRzs",
                Xaankhanh: "17569832310945tZwa",
                Xavinhbao: "1756984830400V5v1b",
                Xanguyenbinhkhiem: "1756997980416nJQoe",
                Xavinhhai: "1756983708915QKaqv",
            };
            return postIdMap[tab];
        },
    },
};
</script>
